import convertToRequiredFormat from '../../../components/react-flow/JsonConverter';

export const createDataProcessorJson = ({ dataModelformField, selectedEntityId }) => {
  const cleanseAlias = `cleanse_${Date.now()}`;
  const matchAlias = `match_${Date.now()}`;
  const survivorshipAlias = `survivorship_${Date.now()}`;
  const workflowId = `dataModel_${Date.now()}`;

  const form_data = [
    { ...dataModelformField?.source },

    {
      ...dataModelformField?.llmMapper,
      formField: {
        ...dataModelformField?.llmMapper?.formField,
        mappings: dataModelformField?.mappings,
      },
    },

    {
      nodeId: `dndnode_${Date.now()}1`,
      nodeName: 'Cleanse',
      formField: {
        alias: cleanseAlias,
        df: dataModelformField?.llmMapper?.formField?.alias,
        entity_id: selectedEntityId,
      },
    },

    {
      nodeId: `dndnode_${Date.now()}2`,
      nodeName: 'Match',
      formField: {
        alias: matchAlias,
        df: cleanseAlias,
        entity_id: selectedEntityId,
      },
    },

    {
      nodeId: `dndnode_${Date.now()}3`,
      nodeName: 'Survivorship',
      formField: {
        alias: survivorshipAlias,
        df: matchAlias,
        entity_id: selectedEntityId,
      },
    },
  ];

  console.log('form_data: ', form_data);

  const formatted = convertToRequiredFormat(form_data, '', workflowId, '');

  return {
    name: '',
    transformer_execution_details: {},
    spark_config: {},
    udf: {},
    steps: formatted?.steps,
  };
};
